module.exports = __webpack_public_path__ + "img/DG.1aa590b6.png";